// extracted by mini-css-extract-plugin
export default {"title":"PatientsLanding_title__cFSw5"};